import matter from 'gray-matter';

export interface BlogPost {
    id: string;
    title: string;
    excerpt: string;
    content: string; // Markdown content as string
    date: string;
    readTime: string;
    category: string;
    image: string;
}

// Helper to sort blogs by date
export const sortBlogsByDate = (blogs: BlogPost[]) => {
    return blogs.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
};

export const getAllBlogs = async (): Promise<BlogPost[]> => {
    // Import all markdown files from content/blogs
    const modules = import.meta.glob('../../content/blogs/*.md', {
        query: '?raw',
        import: 'default',
        eager: true
    });

    const blogs: BlogPost[] = [];

    for (const path in modules) {
        const rawContent = modules[path] as string;
        const { data, content } = matter(rawContent);

        blogs.push({
            id: data.id,
            title: data.title,
            excerpt: data.excerpt,
            content: content,
            date: data.date,
            readTime: data.readTime,
            category: data.category,
            image: data.image,
        });
    }

    return sortBlogsByDate(blogs);
};

export const getBlogById = async (id: string): Promise<BlogPost | undefined> => {
    const blogs = await getAllBlogs();
    return blogs.find((blog) => blog.id === id);
};
